/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { EditorPlugins } from '../../types/EditorPlugins';
import { requiresUsersIntegrationPlugin } from '../requiresUsersIntegrationPlugin/requiresUsersIntegrationPlugin';

// Importing the plugin as a raw string to prevent it from being minified by esbuild.
import UsersIntegration from '../../components/CKEditor5Preview/CKEditor5/UsersIntegration?raw';

/* eslint-disable max-len */
const DESCRIPTION_HEADER = [
	'/**',
	' * The `UsersIntegration` lets you manage user data and permissions.',
	' *',
	' * This is an essential feature when many users work on the same document.',
	' *',
	' * To read more about it, visit the CKEditor 5 documentation: https://ckeditor.com/docs/ckeditor5/latest/features/collaboration/users.html.',
	' */'
].join( '\n' );
/* eslint-enable max-len */

export function getUsersIntegrationPlugin( editorPlugins: EditorPlugins ): string {
	if ( !requiresUsersIntegrationPlugin( editorPlugins ) ) {
		return '';
	}

	const pluginCode = UsersIntegration.match( /class UsersIntegration extends Plugin {[\s\S]+}/ )![ 0 ];

	return `${ DESCRIPTION_HEADER }\n${ pluginCode }`;
}
